export default {
  title: 'Hinnan erittely',
  subtotal: 'Välisumma',
  method_fee: 'Toimitusmaksu',
  tip: 'Tippi',
  service_fee: 'Verkkomaksun käsittely',
  payment_method_upcharge_fee: 'PayPal-maksu',
  discount: 'Alennus',
  taxes: 'Verot',
  total: 'Yhteensä',
};
